import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=16022db1"
import script from "./ChatFooter.vue?vue&type=script&lang=js"
export * from "./ChatFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16022db1')) {
      api.createRecord('16022db1', component.options)
    } else {
      api.reload('16022db1', component.options)
    }
    module.hot.accept("./ChatFooter.vue?vue&type=template&id=16022db1", function () {
      api.rerender('16022db1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/ChatFooter.vue"
export default component.exports